import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../../constants/actionTypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from '../../../actions/phaseActions';
import PhaseForm from '../Identifiers/taskPhaseForm';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Drawer from '../../Common/Drawer/Drawer';
import Icon from '../../Common/Icon';
import Notification from '../../../components/Common/Notification';
import { getDataTableSortFields, getSearchParamSortFields } from '../../../helpers/sortHelper';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import { getNullableOnChangeValue } from '../../../helpers/multiselect';

export class Phase extends React.Component {

    constructor(props, context) {
        super(props, context);

        const newPhase = {
            id: 0,
            name: "",
            description: "",
            isActive: true,
            subscriptionId: props.subscriptionId
        };

        this.state = {
            phases: [],
            totalCount: 0,
            selectedPhase: newPhase,
            tempPhase: newPhase,
            newPhase: newPhase,
            drawerOpen: false,
            isFormValid: true,
            errorMessage: "",
            isFetching: false,
            isSaving: false,
            searchParams: {
                subscriptionId: props.subscriptionId,
                isActive: true,
                pageSize: DEFAULT_PAGE_SIZE,
                pageNumber: 1,
                sortBy: "name",
                sortDir: "asc",
                name: "",
                description: ""
            }
        };
        this.search.bind(this);
    }

    async componentDidMount() {
        await this.search();
    }

    async search() {
        try {
            const result = await this.props.actions.searchPhases(this.state.searchParams);
            const payload = result.payload;
            if (result.type === types.SEARCH_PHASE_SUCCESS) {
                this.setState({ phases: payload.results, totalCount: payload.totalCount });
            } else if (result.type === types.SEARCH_PHASE_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
    }

    async save() {
        const result = await this.props.actions.savePhase(this.state.tempPhase)

        if (result.type === types.CREATE_PHASE_SUCCESS || result.type === types.UPDATE_PHASE_SUCCESS) {
            Notification("success", "Save Successful", "Phase saved successfully")
            this.setState({ drawerOpen: false });
            this.setState({ searchParams: { ...this.state.searchParams, pageNumber: 1 } }, () => {
                this.search();
            });
        } else if (result.type === types.UPDATE_PHASE_FAILURE || result.type === types.CREATE_PHASE_FAILURE) {
            this.setState({ errorMessage: result.payload.message });
            Notification("error", "An Error Occurred", result.payload.message)
        }
    }

    filterByName = (e) => {
        if (e.keyCode == 13) {
            this.search();
        } else {
            this.setState({ searchParams: { ...this.state.searchParams, name: e.target.value } });
        }
    }

    filterByDescription = (e) => {
        if (e.keyCode == 13) {
            this.search();
        } else {
            this.setState({ searchParams: { ...this.state.searchParams, description: e.target.value } });
        }
    }

    onSearchBlur = () => {
        this.search();
    }

    onActiveChange = (e) => {
        const selectedValue = getNullableOnChangeValue(e);
    
        this.setState(prevState => ({
            searchParams: {
                ...prevState.searchParams,
                isActive: selectedValue
            }
        }), () => {
            this.search();
        });
    }

    onPageChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, pageNumber: (e.page + 1) } }, () => {
            this.search();
        });
    }

    onAddNew = () => {
        this.setState({ tempPhase: this.state.newPhase, drawerOpen: true, isFormValid: true });
    }

    // ------- Form Changes

    onFormChange = (name, value) => {
        this.setState({ tempPhase: { ...this.state.tempPhase, [name]: value } });
    }


    // ------- Form Changes



    // ------- Drawer
    saveClick = () => {
        const trimmedName = this.state.tempPhase.name.trim();
    
        if (trimmedName.length < 1) {
            this.setState({ isFormValid: false });
            return false;
        }
    
        this.setState(prevState => ({
            isFormValid: true,
            tempPhase: {
                ...prevState.tempPhase,
                name: trimmedName
            }
        }), this.save);
    
        return false;
    };    

    cancelClick = () => {
        this.setState({ drawerOpen: false });
    }

    selectPhase = (e) => {
        const newValue = e.value || this.state.selectedPhase;
        this.setState({ selectedPhase: newValue, drawerOpen: true, isFormValid: true, tempPhase: newValue });
    }
    // ------- Drawer

    actionTemplate = (rowData) => {
        if (rowData.isActive) {
            return <div className="text-success text-center"><Icon name="check-circle" /></div>;
        } else {
            return <div className="text-danger text-center"><Icon name="times-circle" /></div>;
        }
    }

    onSort = ({ sortField, sortOrder }) => {
        const { sortBy, sortDir } = getSearchParamSortFields(sortField, sortOrder);
        if (sortBy !== this.state.searchParams.sortBy || sortDir !== this.state.searchParams.sortDir) {
            this.setState({
                searchParams: {
                    ...this.state.searchParams,
                    sortBy: sortBy,
                    sortDir: sortDir
                }
            }, this.search);
        }
    }

    render() {

        const activeOptions = [
            { label: "Yes", value: true },
            { label: "No", value: false },
            { label: "All", value: null }
        ];
        
        const activeFilter = (
                            <Dropdown
                                className="ui-column-filter"
                                value={this.state.searchParams.isActive}
                                options={activeOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={this.onActiveChange}
                                placeholder="Select an option"
                            />
                        );
        
        const nameFilterElement =
            <input type="text" className="p-inputtext" placeholder="Filter by Name" size="50" onBlur={this.onSearchBlur} onKeyUp={this.filterByName} />
        ;

        const descriptionFilterElement =
            <input type="text" className="p-inputtext" placeholder="Filter by Description" size="50" onBlur={this.onSearchBlur} onKeyUp={this.filterByDescription} />
        ;

        const { sortField, sortOrder } = getDataTableSortFields(this.state.searchParams);

        return (
            <div>
                {this.state.drawerOpen ?
                    <Drawer isWide={false} title="Phase" onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
                        <PhaseForm
                            phase={this.state.tempPhase}
                            onFormChange={this.onFormChange}
                            isFormValid={this.state.isFormValid}
                            onLogoChange={this.onLogoChange}
                            onSubmit={this.saveClick} />
                    </Drawer>                
                :
                ""
                }


                <LoadingIndicator isLoading={this.state.isFetching || this.state.isSaving} hideWhileLoading={true}>
                    <div className="identifier-header">
                        <div className="title">Phase</div>
                        <div className="close">
                            <button type="button" onClick={this.props.onClose} alt="close popup"><Icon name="times" /></button>
                        </div>
                    </div>

                    <div className="identifier-add-new">
                        <div className="col-sm-12">
                            <button type="button" className="btn btn-primary" onClick={this.onAddNew} alt="close popup"><span className="me-2">Add New</span><Icon name="plus-circle" /></button>
                        </div>
                    </div>

                    <div className="identifier-results-table">
                        <DataTable
                            filterDisplay="row"
                            className="p-datatable-sm p-datatable-striped"
                            value={this.state.phases}
                            selectionMode="single"
                            selection={this.state.selectedPhase}
                            onSelectionChange={this.selectPhase}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSort={this.onSort}
                            >
                            <Column field="name" header="Name" sortable={true} filter={true} filterElement={nameFilterElement} />
                            <Column field="description" header="Description" sortable={true} filter={true} filterElement={descriptionFilterElement} />
                            <Column field="isActive" header="Active" sortable={true} body={this.actionTemplate} style={{ width: '120px' }} filter={true} filterElement={activeFilter} />
                        </DataTable>
                        {
                            this.state.totalCount > this.state.searchParams.pageSize &&
                            <Paginator
                                rows={this.state.searchParams.pageSize}
                                totalRecords={this.state.totalCount}
                                first={(this.state.searchParams.pageNumber - 1) * this.state.searchParams.pageSize}
                                onPageChange={this.onPageChange} />
                        }
                        <div className="results-count">Total records: {this.state.totalCount}</div>
                    </div>
                </LoadingIndicator>

            </div>
        );
    }

}

Phase.propTypes = {
    subscriptionId: PropTypes.number.isRequired,
    actions: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(Phase);

